import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Award, MapPin, Sparkles } from "lucide-react";

const About = () => (
    <div className="bg-cream-100 min-h-screen py-12" data-testid="about-page">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
            <span className="text-xs uppercase tracking-[0.2em] text-saffron-600 font-semibold flex items-center gap-2"><Sparkles className="w-3.5 h-3.5" /> About SouthTrip</span>
            <h1 className="font-display text-4xl lg:text-5xl text-ink mt-2">Kerala-only. By Keralites.</h1>
            <p className="text-ink-light text-base mt-4 leading-relaxed">
                SouthTrip.in was built by a small team of Kochi-born tour planners who got tired of seeing
                travellers overpay for generic packages. We focus exclusively on Kerala — that means we know
                every backwater turn, every hill-station shortcut and every driver by first name.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10">
                {[
                    { icon: MapPin, title: "Kerala-only", text: "We don't sell flights, hotels or other states. Just Kerala — done deeply." },
                    { icon: ShieldCheck, title: "Verified drivers", text: "Every driver is background-checked and Kerala-trained, with hospitality reviews." },
                    { icon: Award, title: "Transparent prices", text: "What you see is what you pay. No hidden ‘driver bata' or fuel-surcharge surprises." },
                ].map((b, i) => (
                    <div key={i} className="bg-white border border-cream-200 rounded-2xl p-5">
                        <span className="w-10 h-10 rounded-lg bg-saffron-50 text-saffron-600 flex items-center justify-center mb-3">
                            <b.icon className="w-5 h-5" />
                        </span>
                        <h3 className="font-semibold text-ink">{b.title}</h3>
                        <p className="text-sm text-ink-light mt-1">{b.text}</p>
                    </div>
                ))}
            </div>
            <div className="mt-12 bg-white border border-cream-200 rounded-2xl p-8 text-center">
                <h2 className="font-display text-2xl text-ink">Plan your Kerala journey today</h2>
                <p className="text-ink-light mt-2 text-sm">From a quick Munnar weekend to a 10-day grand south India circuit.</p>
                <div className="flex items-center justify-center gap-3 mt-5">
                    <Link to="/cab-booking" className="px-5 py-2.5 rounded-xl bg-saffron-500 hover:bg-saffron-600 text-white font-semibold text-sm">Book a cab</Link>
                    <Link to="/tour-packages" className="px-5 py-2.5 rounded-xl border border-cream-200 hover:border-saffron-300 text-ink font-semibold text-sm">Browse packages</Link>
                </div>
            </div>
        </div>
    </div>
);

export default About;
